<template>
  <v-card tile>
    <BaseToolbar
      :title="
        `${userLocal.person && userLocal.person.first_name} ${userLocal.person && userLocal.person.last_name ? userLocal.person.last_name : ''}`
      "
      type-title="icon"
      icon="person"
      :button-save="false"
      :options="[
        {
          text: this.$t('general.assign'),
          name: 'assign',
          show: true
        }
      ]"
      @assign="assign"
      @close="closeUserDrawer"
    />
    <v-card-text v-if="!isLoading" class="pa-0">
      <v-row no-gutters>
        <v-col v-if="user" cols="12" sm="4">
          <v-card tile>
            <v-card-text class="overflow-y-auto" style="height: calc(100vh - 64px)">
              <v-row wrap>
                <v-col cols="12" class="d-flex align-center">
                  <v-avatar :color="color" size="75" class="mr-5">
                    <span class="white--text headline">
                      {{ userLocal.person && userLocal.person.first_name ? userLocal.person.first_name[0].toUpperCase() : '' }}
                      {{ userLocal.person && userLocal.person.last_name ? userLocal.person.last_name[0].toUpperCase() : '' }}
                    </span>
                  </v-avatar>
                  <div>
                    <span class="title font-weight-black">
                      {{ `${userLocal.person && userLocal.person.first_name} ${userLocal.person && userLocal.person.last_name}` }}
                    </span>
                    <br />
                    <span class="caption grey--text text--darken-2">
                      {{ $t('profile.profile.created_at') }}
                      {{ userLocal.created_at | moment('DD/MM/YYYY') }}
                    </span>
                    <br />
                    <span class="font-weight-black">
                      {{ userLocal.email }}
                    </span>
                  </div>
                </v-col>
              </v-row>
              <v-divider />
              <v-row wrap>
                <v-col cols="12">
                  <span class="grey--text text--darken-1 font-weight-black">
                    {{ $t('users.table.organizations') }}
                  </span>
                  <p class="headline green--text text--accent-4 font-weight-black">
                    {{ userLocal.organizations ? userLocal.organizations.length : '' }}
                  </p>
                </v-col>
              </v-row>
              <template v-if="(userLocal.person && userLocal.person.phone) || (userLocal.person && userLocal.person.born_date)">
                <v-divider />
                <v-row wrap>
                  <v-col v-if="userLocal.person.born_date" cols="12">
                    <p class="blue--text text--darken-4 font-weight-black">
                      {{ $t('users.person.born_date') }}
                    </p>
                    <p class="grey--text text--darken-2">
                      {{ userLocal.person.born_date | moment('DD/MM/YYYY') }}
                    </p>
                  </v-col>
                  <v-col v-if="userLocal.person.phone" cols="12">
                    <p class="blue--text text--darken-4 font-weight-black">
                      {{ $t('users.table.phone') }}
                    </p>
                    <p class="grey--text text--darken-2">{{ userLocal.person.phone }}</p>
                  </v-col>
                </v-row>
               
              </template>
              <v-row wrap>
                <v-col cols="12">
                  <v-btn @click="requestResetPasswordLink(userLocal.email)" small color="primary" class="my-4">
                    Request password reset link
                  </v-btn>
                </v-col>
                <v-col @click="copyToClipboard(resetPasswordLink)" cols="12" style="display: flex; flex-direction: column;">
                  <span style="cursor: pointer" color="primary">{{ resetPasswordLink }}</span>
                  <span v-if="showTooltip" style="color: #4BB543">Copiado</span>
                </v-col>
              </v-row>
              <!-- <template v-if="organizationLocal.url || organizationLocal.legal_document">
                <v-divider />
                <v-row wrap>
                  <v-col cols="12" px-4>
                    <v-col v-if="organizationLocal.url" cols="12">
                      <p class="blue--text text--darken-4 font-weight-black">
                        {{ $t('organization.org_url') }}
                      </p>
                      <p class="grey--text text--darken-2">
                        <a
                          :href="organizationLocal.url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ organizationLocal.url }}
                        </a>
                      </p>
                    </v-col>
                    <v-col v-if="organizationLocal.legal_document" cols="12">
                      <p class="blue--text text--darken-4 font-weight-black">
                        {{ $t('organization.org_legal_document') }}
                      </p>
                      <p class="grey--text text--darken-2">{{ organizationLocal.legal_document }}</p>
                    </v-col>
                    <v-col v-if="organizationLocal.country" cols="12">
                      <p class="blue--text text--darken-4 font-weight-black">
                        {{ $t('profile.profile.country') }}
                      </p>
                      <p class="grey--text text--darken-2">{{ organizationLocal.country.name }}</p>
                    </v-col>
                  </v-col>
                </v-row>
              </template> -->
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="user" cols="12" sm="8">
          <v-card class="overflow-y-auto" style="height: calc(100vh - 64px)">
            <v-tabs
              v-model="tabs"
              grow
              slider-color="indigo darken-3"
            >
              <v-tab v-for="tab in tabsTitle" :key="tab">{{ tab }}</v-tab>
              <v-tab v-if="'organizations' in user && user.organizations.find(e => e.id === 1)">
                Permisos admin
              </v-tab>
            </v-tabs>
            <v-divider />
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="userLocal.organizations"
                  class="elevation-0"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-list-item class="px-0">
                          <v-list-item-avatar
                            v-if="item.logo"
                            class="mr-4"
                          >
                            <img :src="item.logo" alt="logo">
                          </v-list-item-avatar>
                          <v-list-item-avatar
                            v-else
                            class="mr-4"
                            :color="generateRandomColor()"
                          >
                            <span class="white--text">
                              {{
                                `${
                                  item.name
                                    ? item.name[0].toUpperCase()
                                    : ''
                                }`
                              }}
                            </span>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              <v-tooltip
                                bottom
                                v-if="item.name.length > 20"
                                color="black"
                              >
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    {{ item.name.length > 20 ? `${item.name.slice(0, 18)}...` : item.name }}
                                  </span>
                                </template>
                                {{ item.name }}
                              </v-tooltip>
                              <span v-else>
                                {{ item.name }}
                              </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              ID: {{ item.id }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="item.url ? item.url.length > 30 : false"
                          color="black"
                        >
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              {{ item.url.length > 30 ? `${item.url.slice(0, 28)}...` : item.url }}
                            </span>
                          </template>
                          {{ item.url }}
                        </v-tooltip>
                        <span v-else>
                          {{ item.url }}
                        </span>
                      </td>
                      <td>
                        <v-menu v-if="item.pivot.id">
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon>
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="showAlert(item.pivot.id)">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ $t('users.unassign') }}
                              </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="pa-4">
                    <template>
                      <v-list>
                        <v-list-item
                          v-for="(mod, i) in computedModules"
                          :key="i"
                        >
                          <v-list-item-content class="ml-10">
                            <v-list-item-title>
                              <b>
                                {{ mod.name }}
                              </b>
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-switch
                              v-model="selectedModules"
                              :value="mod.id"
                              :readonly="loading"
                              color="primary"
                            ></v-switch>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-row dense>
                      <v-col cols="12" class="d-flex justify-end">
                        <v-btn
                          color="primary"
                          :loading="loading"
                          @click="updateModules"
                        >
                          {{ $t('organization.details.tabs.modules.save') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="'organizations' in user && user.organizations.find(e => e.id === 1)">
                <v-card flat>
                  <v-card-text class="pa-4">
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="roleSelected"
                          :items="roles"
                          item-text="name"
                          :item-value="value => value"
                          label="Cargar permisos desde un rol"
                          clearable
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              small
                              color="primary"
                              :disabled="!roleSelected"
                              @click="loadUserPermisssionsFromRole"
                            >
                              Cargar
                            </v-btn>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="sectionSelected"
                          :items="sections"
                          item-text="name"
                          item-value="id"
                          label="Section"
                          clearable
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-simple-table fixed-header height="380px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Name
                          </th>
                          <th class="text-venter" style="width: 0;">
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!filterPermissions.length">
                          <td colspan="2">
                            <div class="text-center pa-12 my-8">
                              <v-img
                                :src="require('@/assets/svg/box_empty.svg')"
                                height="150"
                                max-height="150px"
                                aspect-ratio="1"
                                contain
                              />
                              <div class="grey--text">
                                {{ $t('common.no_results_found') }}
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr
                          v-for="permission in filterPermissions"
                          :key="permission.id"
                        >
                          <td>{{ permission.name }}</td>
                          <td>
                            <v-checkbox
                              v-model="userPermissions"
                              :value="permission.id"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-right">
                        <v-btn
                          color="primary"
                          :loading="loadingUserPermissions"
                          @click="submitUpdateUserPermissions"
                        >
                          {{ $t('actions.save') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <BaseConfirmDialog
      v-if="dialog"
      :title="$t('users.unassign')"
      :description="$t('users.messages.confirm_unassign')"
      :accept-text="$t('users.accept')"
      :cancel-text="$t('users.cancel')"
      @close="cancel"
      @proceed="unassign"
    />
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{ $t('general.loading')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import BaseToolbar from '@/components/BaseToolbar'
import BaseConfirmDialog from '@/components/BaseConfirmDialog'
import { signupService } from '../../services/signup.service.js'
export default {
  components: {
    BaseToolbar,
    BaseConfirmDialog
  },
  async created () {
    await this.loadDefault()
    await this.getAll()
    this.resetPasswordLink = null
    this.showTooltip = false
  },
  watch: {
    async userId (newVal, oldVal) {
      if (newVal) {
        this.isLoading = true
        await this.getUser(newVal)
        await this.getDifferentOrganizations(newVal)
        const permissions = await this.getUserPermissions({ id: newVal })
        this.setUserPermissions(permissions)
      }
    },
    async user (newVal, oldVal) {
      if (newVal.id) {
        // let differentOrganizations = []
        this.isLoading = false
        this.userLocal = JSON.parse(JSON.stringify(newVal))
        this.color = this.generateRandomColor()

        // this.organizations.forEach(el => {
        //   let exist = false

        //   newVal.organizations.forEach(el2 => {
        //     if (el2.id === el.id) {
        //       exist = true
        //     }
        //   })
        //   if (!exist) {
        //     differentOrganizations.push({...el})
        //   }
        // })

        // this.setDifferents(differentOrganizations)
        this.selectedModules = newVal.modules.map(({ id }) => id)
      }
    }
  },
  data () {
    return {
      isLoading: false,
      loadingUserPermissions: false,
      color: '',
      userLocal: {},
      dialog: false,
      selectedToUnassign: null,
      tabs: 0,
      tabsTitle: [
        this.$t('organization.title'),
        this.$t('organization.details.tabs.modules.title')
      ],
      selectedModules: [],
      loading: false,
      headers: [
        {
          text: this.$t('organization.table.org_name'),
          value: 'name',
          class: 'text-no-wrap blue--text text--darken-4',
          width: ''
        },
        {
          text: this.$t('organization.org_url'),
          value: 'url',
          class: 'blue--text text--darken-4'
        },
        {
          text: '',
          value: 'option',
          sortable: false
        }
      ],
      userPermissions: [],
      permissions: [],
      roles: [],
      roleSelected: null,
      sections: [],
      sectionSelected: null,
      resetPasswordLink: null,
      showTooltip: false
    }
  },
  methods: {
    ...mapActions({
      getUser: 'user/getUser',
      getAll: 'organization/getAll',
      getAllUsers: 'user/getAll',
      unassignOrganization: 'user/unassignOrganization',
      updateUserModules: 'userModules/updateUserModules',
      getDifferentOrganizations: 'user/getDifferentOrganizations',
      getRoles: 'roles/getRoles',
      getSections: 'sections/getSections',
      getPermissions: 'permissions/getPermissions',
      getUserPermissions: 'user/getUserPermissions',
      updateUserPermissions: 'user/updateUserPermissions'
    }),
    ...mapMutations({
      changeUser: 'user/changeUser',
      userDrawer: 'user/userDrawer',
      setUserId: 'user/setUserId',
      AssignOrgDrawer: 'user/AssignOrgDrawer',
      setDifferents: 'user/setDifferents'
      // organizationDrawerEdit: 'organization/organizationDrawerEdit',
      // changeOrganizationUser: 'organization/changeOrganizationUser',
      // organizationDrawerUser: 'organization/organizationDrawerUser',
    }),
    async loadDefault () {
      this.roles = await this.getRoles({
        fields: 'id,name,is_admin',
        filter: { is_admin: true },
        limit: 'all',
        sort: 'id:asc',
        include: 'permissions'
      })
      this.sections = await this.getSections({
        fields: 'id,name,is_admin',
        filter: { is_admin: true },
        limit: 'all',
        sort: 'id:asc'
      })
      this.permissions = await this.getPermissions({
        fields: 'id,action_id,section_id,name,slug,is_admin',
        filter: { is_admin: true },
        limit: 'all',
        sort: 'id:asc'
      })
    },
    loadUserPermisssionsFromRole () {
      this.setUserPermissions(this.roleSelected.permissions)
    },
    setUserPermissions (permissions) {
      this.userPermissions = permissions.map(e => e.id)
    },
    async submitUpdateUserPermissions () {
      try {
        this.loadingUserPermissions = true
        this.updateUserPermissions({
          id: this.userId,
          permissions: this.userPermissions
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingUserPermissions = false
      }
    },
    showAlert (id) {
      this.selectedToUnassign = id
      this.dialog = true
    },
    assign () {
      this.AssignOrgDrawer(true)
    },
    cancel () {
      this.selectedToUnassign = null
      this.dialog = false
    },
    unassign () {
      this.dialog = false
      this.unassignOrganization(this.selectedToUnassign)
        .then(
          res => {
            this.selectedToUnassign = null
            this.$noty.success(this.$t('users.messages.unassign_success'))
            this.getAllUsers()
          },
          err => {
            this.$noty.error(this.$t('users.messages.unassign_error'))
          }
        )
    },
    closeUserDrawer () {
      this.setDifferents([])
      this.AssignOrgDrawer(false)
      this.setUserId(null)
      this.userDrawer(false)
      this.changeUser({})
      this.cleanData()
    },
    generateRandomColor () {
      var randomColor = '#000000'.replace(/0/g, function () { return (~~(Math.random() * 16)).toString(16) })
      return randomColor
    },
    async updateModules () {
      this.loading = true
      await this.updateUserModules({
        id: this.user.id,
        modules: this.selectedModules,
        isOrgUser: true
      })
      this.loading = false
    },
    cleanData () {
      this.isLoading = false
      this.loadingUserPermissions = false
      this.color = ''
      this.userLocal = {}
      this.dialog = false
      this.selectedToUnassign = null
      this.tabs = 0
      this.selectedModules = []
      this.loading = false
      this.userPermissions = []
      this.roleSelected = null
      this.sectionSelected = null
      this.resetPasswordLink = null
      this.showTooltip = false
    },
    async requestResetPasswordLink(email){
      this.resetPasswordLink = null
      console.log({email})
      try{
        const res = await signupService.requestPasswordResetLink(email)

        this.resetPasswordLink = res
      }catch(e){
        console.log({e})
      }
    },
    copyToClipboard(str){
      navigator.clipboard.writeText(str);
      this.showTooltip = true
    }
  },
  computed: {
    ...mapState({
      userId: ({ user: { userId } }) => userId,
      user: ({ user: { user } }) => user,
      organizations: ({ organization: { organizations } }) => organizations,
      userModules: ({ userModules: { userModules } }) => userModules
    }),
    computedModules () {
      return this.userModules.map(e => {
        return {
          name: e.name,
          id: e.id
        }
      })
    },
    filterPermissions () {
      return this.permissions.filter(element => {
        return (element.section_id === this.sectionSelected)
      })
    }
  }
}
</script>

<style>

</style>
